import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { IDataIngresoInventario } from '../interfaces';
import { emptyCellObject, formatDateWithTimeAMPM } from '../utils';
import InfoNumeroReferencia from '../components/ui/InfoNumeroReferencia/InfoNumeroReferencia';

export const UseTableColumnsIngresoInventariable = () => {

  const columnBase = useMemo<MRT_ColumnDef<IDataIngresoInventario>[]>(
    () => [
      {
        accessorKey: 'numero_referencia',
        header: '# Referencia',
        size: 150,
      },
      {
        accessorKey: 'movimiento_inventario',
        header: '# Movimiento Kardex',
        size: 150,
        Cell: ({ row }) => {

          return <InfoNumeroReferencia
                    movimiento_inventario_data={row.original.movimiento_inventario_data}
                  />
        }
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'fecha creacion',
        size: 150,
        Cell: ({ row }) => (
          formatDateWithTimeAMPM(row.original.fecha_creacion)
        )
      },
      {
        id: 'bodega_data_nombre',
        accessorKey: 'bodega_data.nombre',
        header: 'bodega',
        size: 150,
        Cell: ({ row }) => emptyCellObject(row.original.bodega_data, 'nombre')
      },
      {
        id: 'ubicacion_data_nombre',
        accessorKey: 'ubicacion_data.nombre',
        header: 'ubicacion',
        size: 150,
        Cell: ({ row }) => emptyCellObject(row.original.ubicacion_data, 'nombre')
      },
      {
        id: 'observacion_1_nombre',
        accessorKey: 'observaciones.observacion_1',
        header: 'Observación',
        size: 150,
        Cell: ({ row }) => emptyCellObject(row.original.observaciones, 'observacion_1')
      },

    ],
    []
  );



  return {
    columnBase
  };
};
